/* __next_internal_client_entry_do_not_use__ Default auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { withStandardComponentWrapper } from 'helpers/HOC';
import { getTestProps } from 'lib/testing/utils';
import ClientStoriesListSearchWidget from 'widgets/ClientStories';
import { tv } from 'tailwind-variants';
import { editingHydrationProps } from 'lib/hooks/useEditingHydrationProps';
import useIsEditing from 'lib/hooks/useIsEditing';
const ClientStories = (props)=>{
    const isEditing = useIsEditing();
    const id = props?.params?.RenderingIdentifier;
    const ClientStoriesData = {
        cardsCTAText: props?.fields?.cardsCTAText,
        params: props?.params
    };
    const { base } = TAILWIND_VARIANTS();
    return /*#__PURE__*/ _jsx("section", {
        id: id,
        "data-component": "authorable/shared/search/clientstories",
        ...editingHydrationProps(isEditing),
        ...getTestProps(`component-search-result-${props?.rendering?.uid}`),
        className: base(),
        children: /*#__PURE__*/ _jsx(ClientStoriesListSearchWidget, {
            rfkId: "rfkid_client_stories",
            ...ClientStoriesData
        })
    });
};
export const Default = withStandardComponentWrapper(ClientStories);
const TAILWIND_VARIANTS = tv({
    slots: {
        base: [
            'flex',
            'flex-col',
            'gap-component-section-container-gutter'
        ]
    }
});
